import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["highlightToday", "selectedDays", "availableDays", "showSelectedDaysAsRange", "disableNextNavAction", "disablePrevNavAction", "onPrevMonthClick", "onNextMonthClick", "onMonthChange", "onDayClick", "Container", "defaultOptions", "disabledDays"],
    _excluded2 = ["month", "previousMonth", "nextMonth", "showNextButton", "showPreviousButton", "disablePrevNavAction", "disableNextNavAction", "calendarProps", "onPreviousClick", "onNextClick"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Calendar/Calendar.js",
    _this = this,
    _templateObject,
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7,
    _templateObject8;

import React from 'react';
import DayPicker from 'react-day-picker';
import { compareAsc, format, startOfMonth, isFirstDayOfMonth, isLastDayOfMonth } from 'date-fns';
import { ArrowLeft as ArrowLeftIcon, ArrowRight as ArrowRightIcon } from '@dls/assets/icons';
import StrikeIcon from './strike.svg';
import { en } from './locale';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import useDevice from '../../core/hooks/useDevice';
import { getDaysNearDisabledDays } from './utils';
import { getStyledText } from '../../helpers/styled';
import Config from '../../config';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
var SMALL_MOBILE_BREAKPOINT = '320px'; // An exception breakpoint for this component only

var Calendar = function Calendar(_ref) {
  var highlightToday = _ref.highlightToday,
      selectedDays = _ref.selectedDays,
      _ref$availableDays = _ref.availableDays,
      availableDays = _ref$availableDays === void 0 ? {} : _ref$availableDays,
      showSelectedDaysAsRange = _ref.showSelectedDaysAsRange,
      disableNextNavAction = _ref.disableNextNavAction,
      disablePrevNavAction = _ref.disablePrevNavAction,
      onPrevMonthClick = _ref.onPrevMonthClick,
      onNextMonthClick = _ref.onNextMonthClick,
      onMonthChange = _ref.onMonthChange,
      onDayClick = _ref.onDayClick,
      Container = _ref.Container,
      _ref$defaultOptions = _ref.defaultOptions,
      defaultOptions = _ref$defaultOptions === void 0 ? {} : _ref$defaultOptions,
      disabledDays = _ref.disabledDays,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var _defaultOptions$today = defaultOptions.today,
      today = _defaultOptions$today === void 0 ? new Date() : _defaultOptions$today,
      _defaultOptions$month = defaultOptions.month,
      month = _defaultOptions$month === void 0 ? new Date() : _defaultOptions$month;
  var selectedDayRange = selectedDays && selectedDays.from && selectedDays.to && correctSelectedDateRange(selectedDays);

  var getDayPickerModifiers = function getDayPickerModifiers() {
    var modifiers = {};
    modifiers.highlighted = today;

    if (disabledDays) {
      var nearDays = getDaysNearDisabledDays(disabledDays);
      modifiers.disabled = disabledDays;
      modifiers.nextLeftDisabled = nearDays.nextLeftDisabledDays;
      modifiers.nextRightDisabled = nearDays.nextRightDisabledDays;
    }

    if (selectedDayRange) {
      modifiers.selectedDays = selectedDayRange;
      modifiers.from = selectedDayRange && selectedDayRange.from;
      modifiers.to = selectedDayRange && selectedDayRange.to;
    }

    return modifiers;
  };

  var handleDayClick = function handleDayClick(day) {
    var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifiers.disabled) {
      return;
    }

    for (var _len = arguments.length, restArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restArgs[_key - 2] = arguments[_key];
    }

    onDayClick.apply(void 0, [day, modifiers].concat(restArgs));
  };

  var renderDayPicker = function renderDayPicker() {
    return /*#__PURE__*/React.createElement(DayPicker, {
      selectedDays: selectedDayRange ? selectedDayRange : selectedDays,
      modifiers: getDayPickerModifiers(),
      initialMonth: month,
      numberOfMonths: isMobile ? 12 : 2 // Show a full year in mobile view
      ,
      navbarElement: function navbarElement(p) {
        return /*#__PURE__*/React.createElement(NavBar, _extends({}, p, {
          calendarProps: {
            onPrevMonthClick: onPrevMonthClick,
            onNextMonthClick: onNextMonthClick
          },
          disableNextNavAction: disableNextNavAction,
          disablePrevNavAction: disablePrevNavAction,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87,
            columnNumber: 11
          }
        }));
      },
      captionElement: function captionElement(p) {
        return /*#__PURE__*/React.createElement(Caption, _extends({}, p, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 95,
            columnNumber: 28
          }
        }));
      },
      weekdayElement: function weekdayElement(_ref2) {
        var weekday = _ref2.weekday;
        return /*#__PURE__*/React.createElement(WeekDay, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 97,
            columnNumber: 9
          }
        }, /*#__PURE__*/React.createElement("abbr", {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98,
            columnNumber: 11
          }
        }, en.weekDay.abbr[weekday]));
      },
      renderDay: function renderDay(day, modifiers) {
        return /*#__PURE__*/React.createElement(DayElement, {
          day: day,
          modifiers: modifiers,
          highlightToday: highlightToday,
          inSelectedRange: showSelectedDaysAsRange,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 9
          }
        });
      },
      onMonthChange: onMonthChange,
      fromMonth: startOfMonth(availableDays.from),
      toMonth: startOfMonth(availableDays.to),
      onDayClick: handleDayClick,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 5
      }
    });
  };

  return /*#__PURE__*/React.createElement(CalendarContainer, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 5
    }
  }, Container ? /*#__PURE__*/React.createElement(Container, {
    selectedDays: selectedDays,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 9
    }
  }, renderDayPicker()) : renderDayPicker());
}; // TODO Sudhir: Documentation and examples, update readme.


Calendar.defaultProps = {
  highlightToday: true,
  showSelectedDaysAsRange: false,
  selectedDays: []
};
export var NavBar = withTheme(function (_ref3) {
  var month = _ref3.month,
      previousMonth = _ref3.previousMonth,
      nextMonth = _ref3.nextMonth,
      showNextButton = _ref3.showNextButton,
      showPreviousButton = _ref3.showPreviousButton,
      disablePrevNavAction = _ref3.disablePrevNavAction,
      disableNextNavAction = _ref3.disableNextNavAction,
      calendarProps = _ref3.calendarProps,
      onPreviousClick = _ref3.onPreviousClick,
      onNextClick = _ref3.onNextClick,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var onPrevMonthClick = function onPrevMonthClick(e) {
    if (typeof calendarProps.onPrevMonthClick === 'function') {
      // TODO Sudhir:Test callback props for `onPrevMonthClick`
      var allowNavigation = calendarProps.onPrevMonthClick(e, {
        month: month,
        previousMonth: previousMonth,
        nextMonth: nextMonth
      });
      return allowNavigation && onPreviousClick();
    } else onPreviousClick();
  };

  var onNextMonthClick = function onNextMonthClick(e) {
    if (typeof calendarProps.onNextMonthClick === 'function') {
      // TODO Sudhir:Test callback props for `onNextMonthClick`
      var allowNavigation = calendarProps.onNextMonthClick(e, {
        month: month,
        previousMonth: previousMonth,
        nextMonth: nextMonth
      });
      return allowNavigation && onNextClick();
    } else onNextClick();
  };

  var coreTheme = rest.coreTheme;
  return /*#__PURE__*/React.createElement(CalendarNavigationContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 261,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(NavigationContainer, {
    onClick: onPrevMonthClick,
    "data-testid": "calendar-nav-item-prev",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 262,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    size: 20,
    color: showPreviousButton && !disablePrevNavAction ? coreTheme.cl_sec_d1 : coreTheme.cl_ter_l4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 266,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(NavigationContainer, {
    onClick: onNextMonthClick,
    "data-testid": "calendar-nav-item-next",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 275,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    size: 20,
    color: showNextButton && !disableNextNavAction ? coreTheme.cl_sec_d1 : coreTheme.cl_ter_l4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 11
    }
  })));
});

var Caption = function Caption(_ref4) {
  var date = _ref4.date;
  var currentMonthStr = format(date, 'MMMM yyyy');
  return /*#__PURE__*/React.createElement(CalendarMonthHeader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 295,
      columnNumber: 10
    }
  }, currentMonthStr);
}; // TODO Sudhir:Render disabled and other states.


export var DayElement = function DayElement(_ref5) {
  var highlightToday = _ref5.highlightToday,
      inSelectedRange = _ref5.inSelectedRange,
      day = _ref5.day,
      modifiers = _ref5.modifiers;
  var highlighted = modifiers.highlighted,
      selected = modifiers.selected,
      from = modifiers.from,
      to = modifiers.to,
      disabled = modifiers.disabled,
      nextLeftDisabled = modifiers.nextLeftDisabled,
      nextRightDisabled = modifiers.nextRightDisabled;
  var dayString = format(day, 'd'),
      testIdRef = format(day, 'dd/MM/yyyy');
  var isDayCellInRangeStart = selected && from;
  var isDayCellInRange = inSelectedRange && selected && !(from || to);
  var isDayCellInRangeEnd = selected && to;
  var isRangeStart = isFirstDayOfMonth(day) || day.getDay() === 0 || nextRightDisabled;
  var isRangeEnd = isLastDayOfMonth(day) || day.getDay() === 6 || nextLeftDisabled;
  var isSelected = !isDayCellInRange && selected && !disabled; // Today day cell UI is not rendered as of now. Will be added once the design is ready.
  // const isTodayHighlighted = highlightToday && highlighted;

  var isTodayHighlighted = highlightToday && highlighted && false;
  return /*#__PURE__*/React.createElement(DayContainer, {
    selected: selected,
    isRangeEnd: isRangeEnd,
    isRangeStart: isRangeStart,
    todayHighlight: isTodayHighlighted,
    isDayCellInRangeStart: isDayCellInRangeStart,
    isDayCellInRange: inSelectedRange && selected,
    isDayCellInRangeEnd: isDayCellInRangeEnd,
    "data-testid": testIdRef,
    disabled: disabled,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 331,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(DayCell, {
    selected: isSelected,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 342,
      columnNumber: 7
    }
  }, dayString), disabled && /*#__PURE__*/React.createElement(DisabledIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 343,
      columnNumber: 20
    }
  }));
};
var NavigationContainer = withTheme(styled.div.withConfig({
  displayName: "Calendar__NavigationContainer",
  componentId: "sc-19xk7gb-0"
})(["", ""], function (_ref6) {
  var coreTheme = _ref6.coreTheme;
  return css(["padding:", "px ", "px ", "px ", "px;flex:1;z-index:1;position:absolute;left:0;right:auto;top:0;:last-child{padding-right:", "px;padding-left:", "px;text-align:right;left:auto;right:0;}"], coreTheme.space_6, coreTheme.space_2, coreTheme.space_2, coreTheme.space_6, coreTheme.space_6, coreTheme.space_2);
}));
var CalendarContainer = withTheme(styled.div.withConfig({
  displayName: "Calendar__CalendarContainer",
  componentId: "sc-19xk7gb-1"
})(["display:inline-block;overflow:hidden;", ";"], function (_ref7) {
  var _coreTheme$calendar$f, _coreTheme$calendar;

  var coreTheme = _ref7.coreTheme;
  return css(["border-radius:", ";", " .DayPicker{display:inline-block;flex-direction:row;}.DayPicker-wrapper{padding:0;position:relative;flex-direction:row;user-select:none;:focus{outline:none;}}.DayPicker-Months{position:relative;display:flex;flex-wrap:nowrap;justify-content:center;flex-direction:column;", "}.DayPicker-Month{position:relative;margin:0;padding:", "px ", "px 0;display:block;border-spacing:0;border-collapse:collapse;", " @media (max-width:", "){padding-left:", "px;padding-right:", "px;}:last-child{border-right:none;}}.DayPicker-Week{display:table-row;}.DayPicker-Weekdays{display:none;", "}.DayPicker-WeekdaysRow{margin-bottom:", "px;display:table-row;}.DayPicker-Body{display:table-row-group;}.DayPicker-Day{padding:0;display:table-cell;border-radius:50%;vertical-align:middle;text-align:center;cursor:pointer;:focus{outline:none;}}font-family:", ";"], coreTheme.rad_xs, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "])), coreTheme.cl_ter_l4), Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        flex-direction: row;\n      "]))), coreTheme.space_4, coreTheme.space_6, Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        padding: ", "px;\n        border-right: 1px solid ", ";\n      "])), coreTheme.space_6, coreTheme.cl_ter_l4), SMALL_MOBILE_BREAKPOINT, coreTheme.space_4, coreTheme.space_4, Config.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        display: table-header-group;\n      "]))), coreTheme.space_6, (_coreTheme$calendar$f = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar = coreTheme.calendar) === null || _coreTheme$calendar === void 0 ? void 0 : _coreTheme$calendar.fontFamily) !== null && _coreTheme$calendar$f !== void 0 ? _coreTheme$calendar$f : coreTheme.ff_sec_thin);
}));
var CalendarMonthHeader = withTheme(getStyledText('boldBody', {
  lineHeight: 'compact'
})(function (_ref8) {
  var _coreTheme$calendar2, _coreTheme$calendar3;

  var coreTheme = _ref8.coreTheme;
  return css(["display:table-caption;box-sizing:border-box;text-align:left;margin:0 calc(((100vw - 48px) / 14) - 10px);", ";", ""], coreTheme !== null && coreTheme !== void 0 && (_coreTheme$calendar2 = coreTheme.calendar) !== null && _coreTheme$calendar2 !== void 0 && _coreTheme$calendar2.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar3 = coreTheme.calendar) === null || _coreTheme$calendar3 === void 0 ? void 0 : _coreTheme$calendar3.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  }, Config.media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        text-align: center;\n        margin: 0 ", "px ", "px;\n      "])), coreTheme.space_4, coreTheme.space_6));
}));
var WeekDay = withTheme(getStyledText('boldBody', {
  lineHeight: 'compact'
})(function (_ref9) {
  var _coreTheme$calendar4, _coreTheme$calendar5;

  var coreTheme = _ref9.coreTheme;
  return css(["display:table-cell;text-align:center;color:", ";", ";text-transform:uppercase;padding:0 0 ", "px;"], coreTheme.cl_sec_d2, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$calendar4 = coreTheme.calendar) !== null && _coreTheme$calendar4 !== void 0 && _coreTheme$calendar4.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar5 = coreTheme.calendar) === null || _coreTheme$calendar5 === void 0 ? void 0 : _coreTheme$calendar5.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_sm
  }, coreTheme.space_4);
}));
var DayContainer = withTheme(styled.div.withConfig({
  displayName: "Calendar__DayContainer",
  componentId: "sc-19xk7gb-2"
})(["", ";display:flex;flex-direction:row;justify-content:center;align-items:center;width:calc((100vw - 43px) / 7);height:calc((100vw - 43px) / 7);position:relative;", " @media (max-width:", "){height:calc(((100vw - 43px) / 7) + 8px);}"], function (_ref10) {
  var _coreTheme$calendar8, _coreTheme$calendar9;

  var todayHighlight = _ref10.todayHighlight,
      isRangeStart = _ref10.isRangeStart,
      isRangeEnd = _ref10.isRangeEnd,
      isDayCellInRange = _ref10.isDayCellInRange,
      isDayCellInRangeStart = _ref10.isDayCellInRangeStart,
      isDayCellInRangeEnd = _ref10.isDayCellInRangeEnd,
      disabled = _ref10.disabled,
      coreTheme = _ref10.coreTheme;
  var doRenderRange = !(isDayCellInRangeStart && isDayCellInRangeEnd);

  var getColor = function getColor() {
    return disabled ? coreTheme.cl_ter_l4 : todayHighlight ? coreTheme.cl_sec_d1 : coreTheme.cl_ter_l1;
  };

  var getTypeStyle = function getTypeStyle() {
    var _coreTheme$calendar$f2, _coreTheme$calendar6, _coreTheme$calendar$f3, _coreTheme$calendar7;

    return todayHighlight ? css(["font-family:", ";letter-spacing:-0.04em;position:relative;"], (_coreTheme$calendar$f2 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar6 = coreTheme.calendar) === null || _coreTheme$calendar6 === void 0 ? void 0 : _coreTheme$calendar6.fontFamily) !== null && _coreTheme$calendar$f2 !== void 0 ? _coreTheme$calendar$f2 : coreTheme.ff_sec_bold) : css(["font-family:", ";letter-spacing:normal;"], (_coreTheme$calendar$f3 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar7 = coreTheme.calendar) === null || _coreTheme$calendar7 === void 0 ? void 0 : _coreTheme$calendar7.fontFamily) !== null && _coreTheme$calendar$f3 !== void 0 ? _coreTheme$calendar$f3 : coreTheme.ff_sec_thin);
  };

  var renderRange = function renderRange() {
    return css(["::before{content:'';position:absolute;margin:auto;top:0;bottom:0;height:32px;left:", ";right:", ";width:", ";background-color:", ";color:inherit;display:", ";align-items:center;justify-content:center;", "}"], isDayCellInRangeStart ? '50%' : 'auto', isDayCellInRangeEnd ? '50%' : 'auto', isDayCellInRangeStart || isDayCellInRangeEnd ? '51%' : '101%', coreTheme.cl_sec_l2, doRenderRange ? 'flex' : 'none', disabled && css(["background-color:", ";"], coreTheme.cl_white));
  };

  var renderRangeStart = function renderRangeStart() {
    return css(["::before{border-top-left-radius:16px;border-bottom-left-radius:16px;}"]);
  };

  var renderRangeEnd = function renderRangeEnd() {
    return css(["::before{border-top-right-radius:16px;border-bottom-right-radius:16px;}"]);
  };

  return css(["", ";color:", ";", ";", " ", " ", ""], coreTheme !== null && coreTheme !== void 0 && (_coreTheme$calendar8 = coreTheme.calendar) !== null && _coreTheme$calendar8 !== void 0 && _coreTheme$calendar8.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar9 = coreTheme.calendar) === null || _coreTheme$calendar9 === void 0 ? void 0 : _coreTheme$calendar9.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  }, getColor(), getTypeStyle(), isDayCellInRange && !(isRangeStart && isDayCellInRangeEnd) && !(isRangeEnd && isDayCellInRangeStart) && renderRange(), isRangeStart && renderRangeStart(), isRangeEnd && renderRangeEnd());
}, Config.media.sm(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    height: 43px;\n    width: 43px;\n  "]))), SMALL_MOBILE_BREAKPOINT));
var DayCell = withTheme(getStyledText('body', {
  lineHeight: 'compact'
})(function (_ref11) {
  var _coreTheme$calendar$f4, _coreTheme$calendar10, _coreTheme$calendar$f5, _coreTheme$calendar11, _coreTheme$calendar12, _coreTheme$calendar13;

  var selected = _ref11.selected,
      coreTheme = _ref11.coreTheme;
  return css(["border-radius:", "px;width:38px;height:38px;background-color:transparent;color:inherit;z-index:1;display:flex;justify-content:center;align-items:center;", "}", " ", ""], coreTheme.space_6, Object.assign({}, responsiveStyles({
    fontSize: (_coreTheme$calendar$f4 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar10 = coreTheme.calendar) === null || _coreTheme$calendar10 === void 0 ? void 0 : _coreTheme$calendar10.fontSize) !== null && _coreTheme$calendar$f4 !== void 0 ? _coreTheme$calendar$f4 : [20, 20]
  }, coreTheme)), selected && css(["background-color:", ";color:", ";font-family:", ";"], coreTheme.cl_sec_d1, coreTheme.cl_white, (_coreTheme$calendar$f5 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar11 = coreTheme.calendar) === null || _coreTheme$calendar11 === void 0 ? void 0 : _coreTheme$calendar11.fontFamily) !== null && _coreTheme$calendar$f5 !== void 0 ? _coreTheme$calendar$f5 : coreTheme.ff_sec_bold), Config.media.sm(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        ", ";\n        \n      "])), coreTheme !== null && coreTheme !== void 0 && (_coreTheme$calendar12 = coreTheme.calendar) !== null && _coreTheme$calendar12 !== void 0 && _coreTheme$calendar12.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$calendar13 = coreTheme.calendar) === null || _coreTheme$calendar13 === void 0 ? void 0 : _coreTheme$calendar13.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  }));
}));
var DisabledIcon = withTheme(styled(StrikeIcon).withConfig({
  displayName: "Calendar__DisabledIcon",
  componentId: "sc-19xk7gb-3"
})(["position:absolute;margin:auto;left:0;right:0;z-index:1;"]));
var CalendarNavigationContainer = withTheme(styled.div.withConfig({
  displayName: "Calendar__CalendarNavigationContainer",
  componentId: "sc-19xk7gb-4"
})(["display:none;", ""], Config.media.sm(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n  "])))));

var correctSelectedDateRange = function correctSelectedDateRange(_ref12) {
  var from = _ref12.from,
      to = _ref12.to;
  return compareAsc(to, from) === -1 ? {
    to: from,
    from: to
  } : {
    from: from,
    to: to
  };
};

export default Calendar;